export default "__VITE_ASSET__B5H4QEjF__"